import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the top on every route change. Fixes the "page starts mid-scroll"
// issue when navigating via footer / header links from a deep-scrolled page.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
